import { siteMeta, siteStats } from '@/mocks/home';

export default function CoverHero() {
  return (
    <section id="cover" className="w-full border-b-2 border-foreground-950">
      <div className="grid lg:grid-cols-2">
        <div className="flex flex-col justify-between gap-8 border-b border-foreground-950/15 p-6 md:p-12 lg:border-b-0 lg:border-r">
          <div>
            <div className="flex flex-wrap items-center gap-3">
              <span className="rounded-sm bg-accent-100 px-2.5 py-1 font-label text-[11px] font-medium tracking-widest text-accent-900">
                封面专题 / COVER STORY
              </span>
              <span className="font-label text-[11px] tracking-widest text-foreground-500">
                {siteMeta.issue} · {siteMeta.editor}
              </span>
            </div>

            <h2 className="mt-6 font-heading text-3xl font-black leading-[1.15] text-foreground-950 text-balance md:text-5xl">
              光环的背面，
              <br />
              才是故事真正的开场
            </h2>

            <p className="mt-5 max-w-xl text-sm leading-loose text-foreground-600 md:text-base">
              覆盖黑料反差明星、网红、主播与公众人物，按身份分类呈现反差事件。无论关注娱乐圈还是直播圈，都能快速找到对应人物与相关爆料。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#feature"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-book-open-line" />
                阅读本期封面
              </a>
              <a
                href="#heat"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-950 px-6 py-3 font-label text-sm font-medium text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50"
              >
                <i className="ri-fire-line" />
                查看反差热度榜
              </a>
            </div>
          </div>

          <dl className="grid grid-cols-2 gap-4 border-t border-dashed border-foreground-950/25 pt-6 sm:grid-cols-4">
            {siteStats.map((stat) => (
              <div key={stat.label}>
                <dt className="font-label text-[11px] tracking-wider text-foreground-500">{stat.label}</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  {stat.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative min-h-[320px] overflow-hidden bg-foreground-900 md:min-h-[520px]">
          <img
            src="https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20art%2C%20dramatic%20chiaroscuro%20spotlight%20on%20an%20empty%20vintage%20theatre%20stage%20with%20a%20single%20vintage%20microphone%20and%20torn%20paper%20curtains%2C%20deep%20crimson%20and%20warm%20gold%20tones%20on%20aged%20cream%20newsprint%20texture%2C%20high%20contrast%20noir%20lighting%2C%20artistic%20abstract%20composition%2C%20no%20text%2C%20no%20people%2C%20cinematic%20grain%2C%20sophisticated%20print%20magazine%20aesthetic&width=1000&height=1250&seq=hero-cover-0910&orientation=portrait"
            alt="黑料反差本期封面主视觉，舞台聚光灯下的反差意象"
            title="黑料反差 - 本期封面主视觉"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/25 to-foreground-950/10" />

          <div className="absolute left-5 top-5 flex flex-col gap-2">
            <span className="w-fit rounded-sm bg-background-50/90 px-2.5 py-1 font-label text-[11px] font-bold tracking-widest text-foreground-950">
              {siteMeta.issue}
            </span>
            <span className="w-fit rounded-sm bg-primary-500 px-2.5 py-1 font-label text-[11px] font-medium tracking-widest text-background-50">
              反差观察 · 本周特辑
            </span>
          </div>

          <div className="absolute bottom-0 left-0 right-0 p-5 md:p-8">
            <p className="font-heading text-lg font-bold text-background-50 md:text-2xl">
              把光环翻过来，看看背面写的是什么
            </p>
            <p className="mt-2 font-label text-xs text-background-200">
              明星 · 网红 · 主播 · 公众人物 — 四类身份，统一归档
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}